import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {CustomerMetricsService} from "./service/customerMetricsService";
import {FormControl, FormGroup} from "@angular/forms";
import {first} from "rxjs/operators";
import {CustomerMetricsList} from "./models/customerMetricsList";
import {CustomerMetrics} from "./models/customerMetrics";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";

@Component({
    templateUrl: './firstSale.component.html',
    styleUrls: ['./firstSale.component.scss']
})

export class FirstSaleComponent implements OnDestroy, OnInit {
    dateRange: FormGroup;
    fastDate: string = 'lastWeek';
    reportData: CustomerMetrics[];
    onlineReportData: CustomerMetrics[];
    stationarReportData: CustomerMetrics[];
    totalSaleSummary: number = 0;
    onlineSaleSummary: number = 0;
    stationarSaleSummary: number = 0;

    constructor(
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private customerMetricsService: CustomerMetricsService,
    ) {
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Reports');

        let today = new Date();

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });
    }

    ngOnInit() {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.updateReportData(start, end);
    }

    ngOnDestroy(): void {

    }

    updateReportData(createdAt: string, createdAtTo: string): void {
        this.reportData = [];
        this.customerMetricsService.get(createdAt, createdAtTo, 'FIRST_TRANSACTION').pipe(first()).subscribe((res: CustomerMetricsList) => {
            this.reportData = res.items;

            for (let i=0; i<this.reportData.length; i++) {
                this.totalSaleSummary += this.reportData[i].quantity;
            }
        });

        this.customerMetricsService.get(createdAt, createdAtTo, 'FIRST_STATIONAR_SHOPPING').pipe(first()).subscribe((res: CustomerMetricsList) => {
            this.stationarReportData = res.items;

            for (let i=0; i<this.stationarReportData.length; i++) {
                this.stationarSaleSummary += this.stationarReportData[i].quantity;
            }
        });

        this.customerMetricsService.get(createdAt, createdAtTo, 'FIRST_ONLINE_SHOPPING').pipe(first()).subscribe((res: CustomerMetricsList) => {
            this.onlineReportData = res.items;

            for (let i=0; i<this.onlineReportData.length; i++) {
                this.onlineSaleSummary += this.onlineReportData[i].quantity;
            }
        });
    }

    convertDateToString(date: Date): string {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    };

    today() {
        this.fastDate = 'today';
        let start = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date()),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, start);
    }

    yesterday() {
        this.fastDate = 'yesterday';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-1)));

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-1))),
            end: new FormControl(new Date(today.setDate(today.getDate()-1))),
        });

        this.updateReportData(start, start);
    }

    lastWeek() {
        this.fastDate = 'lastWeek';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setDate(today.getDate()-7)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
    }

    lastMonth() {
        this.fastDate = 'lastMonth';
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        this.dateRange = new FormGroup({
            start: new FormControl(new Date(today.setDate(today.getDate()-7))),
            end: new FormControl(new Date()),
        });

        this.updateReportData(start, end);
    }

    reloadStats(event: MatDatepickerInputEvent<any>) {
        let today = new Date();
        let start = this.convertDateToString(new Date(today.setMonth(today.getMonth()-1)));
        let end = this.convertDateToString(new Date());

        try {
            start = this.dateRange.get('start').value.format('YYYY-MM-DD');
        } catch (e) {
            start = this.convertDateToString(this.dateRange.get('start').value);
        }

        try {
            end = this.dateRange.get('end').value.format('YYYY-MM-DD');
        } catch (e) {
            end = this.convertDateToString(this.dateRange.get('end').value);
        }

        this.updateReportData(start, end);
    }
}
